module.exports = __webpack_public_path__ + "img/icon-error.e3e87a46.svg";